<template>
    <div ref="modal" class="modal" tabindex="-1" role="dialog" @hidden="hidden" id="modalcito">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title text-center"> <b>Cambiar Estado Del Participante en el Sistema</b> </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body text-center">
                <p> Seleccione el nuevo estado de este participante </p>
                <select v-model="estado" class="">
                  <option value="PREINSCRITO">PREINSCRITO</option>
                  <option value="INSCRITO">INSCRITO</option>
                  <option value="INSCRITO_CERTIFICACION">INSCRITO_CERTIFICACION</option>
                  <option value="RETIRADO">RETIRADO</option>
                  <option value="CAMBIADO">CAMBIADO</option>
                  <option value="CONGELADO">CONGELADO</option>
                  <option value="PAGO_INSCRIPCION">PAGO_INSCRIPCION</option>
                  <option value="PAGADO">PAGADO</option>
                  <option value="POR_CIERRE">POR_CIERRE</option>
                  <option value="POR_CAMBIO">POR_CAMBIO</option>
                  <option value="POR_GENERAR_PLAN_PAGOS">POR_GENERAR_PLAN_PAGOS</option>
                </select>
            </div>
            
            <AAlertas 
              ref="zalertar" 
              v-bind:msgSuccess="'La operacion se realizo satisfactoriamente, revise el correo para ver el resultado.'"
              v-bind:msgLoading="'Aplicando...'"
              />
            <div class="modal-footer">
                <button @click="submit" :disabled="!activo" type="button" class="btn btn-azul">Aceptar</button>
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
import AAlertas from '@/components/AAlertas.vue'
import gql from 'graphql-tag'

    export default {
        props: {
          obj:{ // {xid:Number,xtitle:String,xbody:String,xusername:Object,xestado:Number}
            type: Object,
            required: true
          },
        },
        data(){
          return{ 
            activo: true,
            estado: null,
            correo_to:null,
          }
        },
        components:{AAlertas}, 
        watch:{
            'obj.xid': function(){ 
                if( this.obj.xid == null ) return;
                this.$refs.zalertar.reset(); 
                this.activo = true;
                window.console.log( "MODALCITOl",this.obj ); 

                var curr = this.obj.inscripcion.estado_ins;
                if( curr == 0 ) this.estado = 'PREINSCRITO';
                else if( curr == 1 ) this.estado = 'INSCRITO';
                else if( curr == 2 ) this.estado = 'INSCRITO_CERTIFICACION';
                else if( curr == 3 ) this.estado = 'RETIRADO';
                else if( curr == 4 ) this.estado = 'CAMBIADO';
                else if( curr == 5 ) this.estado = 'CONGELADO';
                else if( curr == 6 ) this.estado = 'PAGO_INSCRIPCION';
                else if( curr == 7 ) this.estado = 'PAGADO';
                else if( curr == 8 ) this.estado = 'POR_CIERRE';
                else if( curr == 9 ) this.estado = 'POR_CAMBIO';
                else if( curr == 10 ) this.estado = 'POR_GENERAR_PLAN_PAGOS';

                if( !this.obj.sede.correos ){
                  this.activo = false;
                  this.$refs.zalertar.invalido("ERROR: la sede no tiene correo."); 
                }else{
                  var cor = this.obj.sede.correos.find( x => x.tipo == 0 );
                  window.console.log( "MODALL ",cor ); 
                  if( cor ) {
                    this.correo_to = cor.direccion;
                  }
                  else{
                    this.activo = false;
                    this.$refs.zalertar.invalido("ERROR: la sede no tiene correo del tipo 0 (corporativo)."); 
                  }
                }
            },
            'obj':function(){ 
                this.$refs.zalertar.reset();
                this.activo = true;
            }
        },
        methods:{
          hidden(){
            this.$refs.zalertar.cargando();
          },
          submit(){
            this.$refs.zalertar.cargando(); 
            //this.estado = parseInt( this.estado )
            window.console.log( "CAMBIANDO ESTADO DEL ESTUDIANTE: ",this.obj,this.estado );
            var curr = this.obj.inscripcion.estado_ins;
            var vue = this;

            var body = window.stringifyObject( {
              inscripcion_id:this.obj.xid,
              programa_id:this.obj.programa.id,
              estudiante_id:this.obj.estudiante.id,
              current_status: 1,
              desired_status: 1,
            } );

            if( curr == 0 ) body = body.replace( 'current_status: 1','current_status:PREINSCRITO' );
            else if( curr == 1 ) body = body.replace( 'current_status: 1','current_status:INSCRITO' );
            else if( curr == 2 ) body = body.replace( 'current_status: 1','current_status:INSCRITO_CERTIFICACION' );
            else if( curr == 3 ) body = body.replace( 'current_status: 1','current_status:RETIRADO' );
            else if( curr == 4 ) body = body.replace( 'current_status: 1','current_status:CAMBIADO' );
            else if( curr == 5 ) body = body.replace( 'current_status: 1','current_status:CONGELADO' );
            else if( curr == 6 ) body = body.replace( 'current_status: 1','current_status:PAGO_INSCRIPCION' );
            else if( curr == 7 ) body = body.replace( 'current_status: 1','current_status:PAGADO' );
            else if( curr == 8 ) body = body.replace( 'current_status: 1','current_status:POR_CIERRE' );
            else if( curr == 9 ) body = body.replace( 'current_status: 1','current_status:POR_CAMBIO' );
            else if( curr == 10 ) body = body.replace( 'current_status: 1','current_status:POR_GENERAR_PLAN_PAGOS' );

            if( this.estado == 'PREINSCRITO' ) body = body.replace( 'desired_status: 1','desired_status:PREINSCRITO' );
            else if( this.estado == 'INSCRITO' ) body = body.replace( 'desired_status: 1','desired_status:INSCRITO' );
            else if( this.estado == 'INSCRITO_CERTIFICACION' ) body = body.replace( 'desired_status: 1','desired_status:INSCRITO_CERTIFICACION' );
            else if( this.estado == 'RETIRADO' ) body = body.replace( 'desired_status: 1','desired_status:RETIRADO' );
            else if( this.estado == 'CAMBIADO' ) body = body.replace( 'desired_status: 1','desired_status:CAMBIADO' );
            else if( this.estado == 'CONGELADO' ) body = body.replace( 'desired_status: 1','desired_status:CONGELADO' );
            else if( this.estado == 'PAGO_INSCRIPCION' ) body = body.replace( 'desired_status: 1','desired_status:PAGO_INSCRIPCION' );
            else if( this.estado == 'PAGADO' ) body = body.replace( 'desired_status: 1','desired_status:PAGADO' );
            else if( this.estado == 'POR_CIERRE' ) body = body.replace( 'desired_status: 1','desired_status:POR_CIERRE' );
            else if( this.estado == 'POR_CAMBIO' ) body = body.replace( 'desired_status: 1','desired_status:POR_CAMBIO' );
            else if( this.estado == 'POR_GENERAR_PLAN_PAGOS' ) body = body.replace( 'desired_status: 1','desired_status:POR_GENERAR_PLAN_PAGOS' );

            var sql = gql`mutation{ cambioEstadoInscripcion(input:${body}){ok,errors{message}} }`;
            window.console.log( sql );

            this.$apollo.mutate({
              mutation: sql,
            }).then((data) => {
              window.console.log(data);
              if( data.data.cambioEstadoInscripcion.ok ){
                vue.$refs.zalertar.success();
              }else{
                var errores = JSON.stringify(data.data.cambioEstadoInscripcion.errors);
                var obj = JSON.parse( errores );
                var vals = '';
                obj.forEach(function(k){ delete k.__typename; vals += Object.values(k)+" \n\t"; });
                //vue.msg = vals;
                vue.msg = '';
                window.console.log( "ERRORESSSSSSS: ",vals );
                vue.activo = true;
                vue.$refs.zalertar.invalido( vals );
              }
              
            }).catch((error) => {
              window.console.error(error);
              vue.$refs.zalertar.invalido();
            });
          }
        },
  mounted(){
    var vue = this;
    window.$('#modalmoodle').on('hidden.bs.modal',function(){
      vue.msg = ''
      //vue.programa = {}
      vue.activo = true;
      vue.$refs.zalertar.reset();
    })
  }
    }
</script>